// extracted by mini-css-extract-plugin
export default {"container":"styles-module--container--7M4sc","title":"styles-module--title--MCCTz"};